import { invoke, isTauri } from '@tauri-apps/api/core';
import type { MoneySoundId } from '../state/childCelebrationPreferences';

let platformLookup: Promise<string | null> | null = null;

function mobilePlatform(): Promise<string | null> {
  platformLookup ??= invoke<string>('runtime_platform').catch(() => null);
  return platformLookup;
}

/**
 * Requests the native iOS jingle when it is available. `null` means callers
 * should use their normal Web Audio path. A resolved `false` means this Tauri
 * host is not iOS; a rejected promise means native playback failed and callers
 * should also fall back gracefully.
 *
 * The native platform query is intentional. iPadOS may present a desktop-like
 * browser user-agent even inside the iOS Tauri host, so user-agent detection
 * can silently skip the AVFoundation path on a real Apple device.
 */
export function playNativeRewardSound(soundId: MoneySoundId): Promise<boolean> | null {
  if (!isTauri()) return null;
  return mobilePlatform().then((platform) => {
    if (platform !== 'ios') return false;
    return invoke('plugin:chorepop-reward-audio-ios|play_reward_sound', { soundId }).then(
      () => true,
    );
  });
}

export function playNativeCoinJingle(): Promise<boolean> | null {
  return playNativeRewardSound('coin-jingle');
}
